<script>
import { ref, watchEffect, toRef } from 'vue'
import { useBreakpoints, BREAKPOINTS } from '@/plugins/global'
export default {
  name: 'renderless-toggle',
  props: {
    initial: {
      type: Boolean,
      required: false,
      default: false
    },
    breakpoint: {
      type: String,
      required: false,
      validator: (value) => Object.keys(BREAKPOINTS).includes(value),
      default: null
    }
  },
  setup (props, { slots }) {
    const breakpoints = useBreakpoints()
    const breakpoint = props.breakpoint && breakpoints[props.breakpoint]
    const initial = toRef(props, 'initial')
    const active = ref(initial.value)
    watchEffect(() => breakpoint && (active.value = !breakpoint.value))
    const toggle = (payload) => {
      if (breakpoint && !breakpoint.value) {
        return
      }
      active.value = payload !== undefined ? payload : !active.value
    }
    return () => slots.default({
      active: active.value,
      toggle
    })
  }
}
</script>
